import { AIDocType } from "@roc/feature-documents"

export const getTypeKey = (type: AIDocType) => {
  return Object.keys(AIDocType).find(key => AIDocType[key] === type)
}

export const emptyTableText: Record<string, string> = {
  IN_PROGRESS: 'Processing - This may take a few seconds. Click Refresh to check for results.',
  SUCCESS: 'No data extracted.',
  FAILED: 'No data extracted.',
};